var map = {
	"./Finland.json": 395,
	"./Sweeden.json": 396,
	"./cs-CZ.json": 397,
	"./da.json": 398,
	"./de.json": 399,
	"./en.json": 400,
	"./es.json": 401,
	"./fr.json": 402,
	"./hi-IN.json": 403,
	"./hu-HU.json": 404,
	"./it.json": 405,
	"./ja.json": 406,
	"./ko.json": 407,
	"./ms-MY.json": 408,
	"./nl.json": 409,
	"./no-norway.json": 410,
	"./pl-PL.json": 411,
	"./pt.json": 412,
	"./ru-RU.json": 413,
	"./sk-SK.json": 414,
	"./th-TH.json": 415,
	"./tr-TR.json": 416,
	"./vi-VN.json": 417,
	"./zh-TW.json": 418,
	"./zh.json": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 394;